import SEO from "../components/SEO";
import { Reveal } from "../components/Reveal";
import { SEO_META, SITE } from "../config/site";

const Section = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="font-display text-xl font-bold tracking-tight">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-obsidian/65">{children}</div>
  </section>
);

const Layout = ({ eyebrow, title, intro, children }) => (
  <section className="container-site py-16 lg:py-24" data-testid={`legal-${eyebrow.toLowerCase().replace(/\s+/g, "-")}`}>
    <Reveal>
      <div className="max-w-3xl">
        <p className="eyebrow">{eyebrow}</p>
        <h1 className="mt-4 font-display text-3xl font-black leading-[1.08] tracking-tight sm:text-4xl">{title}</h1>
        <p className="mt-4 text-sm leading-relaxed text-obsidian/55">{intro}</p>
        {children}
      </div>
    </Reveal>
  </section>
);

export const Privacy = () => {
  const meta = SEO_META.privacy;
  return (
    <>
      <SEO title={meta.title} description={meta.description} path={meta.path} />
      <Layout
        eyebrow="Privacy Policy"
        title="How we handle your information"
        intro={`This policy explains what information ${SITE.name} collects through this website and how it is used.`}
      >
        <Section title="Information we collect">
          <p>When you submit a quotation request or contact enquiry, we collect the details you provide: your name, company name, business email, phone or WhatsApp number, country, requirement details and any files you choose to upload (such as tech packs, reference images or logos).</p>
        </Section>
        <Section title="How we use it">
          <p>We use this information only to review your requirement, prepare quotations, communicate with you about your enquiry and coordinate potential orders. We do not sell, rent or share your information with third parties for marketing purposes.</p>
        </Section>
        <Section title="Storage and retention">
          <p>Enquiry details are stored securely in our systems and retained only as long as needed to handle your enquiry and any resulting business relationship.</p>
        </Section>
        <Section title="Your choices">
          <p>You may ask us to correct or delete the information you have submitted at any time by emailing {SITE.email}.</p>
        </Section>
        <Section title="Contact">
          <p>Questions about this policy can be sent to {SITE.email}.</p>
        </Section>
      </Layout>
    </>
  );
};

export const Terms = () => {
  const meta = SEO_META.terms;
  return (
    <>
      <SEO title={meta.title} description={meta.description} path={meta.path} />
      <Layout
        eyebrow="Terms & Conditions"
        title="Terms of using this website"
        intro={`These terms govern the use of the ${SITE.name} website and enquiries submitted through it.`}
      >
        <Section title="Nature of this website">
          <p>This website presents the business-to-business uniform manufacturing and export services of {SITE.name}, based in India. It is intended for business buyers and does not offer retail sales.</p>
        </Section>
        <Section title="Enquiries and quotations">
          <p>Submitting a quotation request or contact form does not create a contract. Quotations, minimum order quantities, production timelines, sample arrangements and shipping terms are confirmed individually in writing for each order, based on product, quantity, customization and project requirements.</p>
        </Section>
        <Section title="Content accuracy">
          <p>We aim to keep product and service information accurate. Images on this website are illustrative of uniform categories and may not represent a specific finished product. Final specifications are always confirmed during the development and approval stage.</p>
        </Section>
        <Section title="Intellectual property">
          <p>The Cleef Empire name, logo and website content belong to {SITE.name} and may not be reproduced without written permission. Buyer logos, tech packs and brand assets shared with us remain the property of the buyer and are used only to fulfil their orders.</p>
        </Section>
        <Section title="Contact">
          <p>Questions about these terms can be sent to {SITE.email}.</p>
        </Section>
      </Layout>
    </>
  );
};
